/* global URL_API_REST */
import axios from 'axios';
import { getDeliveryPersonJwt, getDeliveryCommerceId } from './deliveryPersonAxios';

const instance = axios.create({
  baseURL: URL_API_REST,
  timeout: 30 * 1000,
  headers: {},
});

instance.interceptors.request.use(
  function (config) {
    const id_commerce = localStorage.getItem('id_commerce');
    const token = localStorage.getItem('token');

    // PLI-2031: Fallback al JWT del delivery_person en memoria
    const effectiveToken = token || getDeliveryPersonJwt();
    const effectiveCommerceId = id_commerce || getDeliveryCommerceId();

    if (effectiveToken && config.headers) {
      if (effectiveCommerceId) {
        (config.headers as unknown as { id_comercio: string }).id_comercio = effectiveCommerceId;
      }
      if (!config.headers.Authorization)
        (config.headers as unknown as { Authorization: string }).Authorization = `Bearer ${effectiveToken}`;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export default instance;
